import { ComponentChildren } from 'preact';
import { baseStyles, userSelectStyles } from './themes/VisStatusMessageStyles.css';
import { HTMLAttributesSignalExcluded } from '../utils/UNSAFE_attributeUtils';
import { Flex } from '../UNSAFE_Flex';
import { classNames } from '../utils/UNSAFE_classNames';

export type Props = {
  /**
   * The children to put in the grid.
   */
  children: ComponentChildren;
  isSelectable?: false;
  activeId?: string;
  'aria-label'?: HTMLAttributesSignalExcluded['aria-label'];
};

export function VisStatusMessage({ children, ...otherProps }: Props) {
  const itemClasses = classNames([otherProps.isSelectable ? '' : userSelectStyles, baseStyles]);

  return (
    <div
      class={itemClasses}
      tabIndex={0}
      aria-label={otherProps['aria-label']}
      aria-activedescendant={otherProps.activeId}>
      <Flex width="100%" height="100%" justify="center" align="center">
        {children}
      </Flex>
    </div>
  );
}
